import React from 'react';

export const fmt = (n, opts = {}) => {
  const { sign = false, cents = true } = opts;
  const abs = Math.abs(n);
  const s = abs.toLocaleString('en-US', {
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
  const pre = n < 0 ? '-' : sign ? '+' : '';
  return `${pre}$${s}`;
};

// Display form of fmt(): the same text, with the "$" in its own span so CSS
// can set it smaller than the figure (.cur in App.css). Anything that needs a
// plain string — aria-labels, titles, <option> text, SVG <text> — keeps fmt().
export const money = (n, opts) => {
  const s = fmt(n, opts);
  const i = s.indexOf('$');
  return React.createElement(
    React.Fragment,
    null,
    s.slice(0, i),
    React.createElement('span', { className: 'cur' }, '$'),
    s.slice(i + 1),
  );
};

export const fmtK = (n) => {
  const abs = Math.abs(n);
  if (abs >= 1000) return `${n < 0 ? '-' : ''}$${(abs / 1000).toFixed(abs >= 10000 ? 0 : 1)}k`;
  return fmt(n, { cents: false });
};

export const monthName = (dt) => dt.toLocaleDateString('en-US', { month: 'short' });

export const dayLabel = (dt) => {
  const d = dt instanceof Date ? dt : new Date(dt);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const relDay = (dt, today = new Date()) => {
  const d = dt instanceof Date ? dt : new Date(dt);
  const t = new Date(today);
  t.setHours(0, 0, 0, 0);
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  const diff = Math.round((x - t) / 86400000);
  if (diff === 0) return 'Today';
  if (diff === 1) return 'Tomorrow';
  if (diff === -1) return 'Yesterday';
  if (diff > 0 && diff < 7) return `in ${diff} days`;
  return dayLabel(x);
};

// Coarse "how fresh is this" phrasing. Deliberately vague past a day — the
// point is reassurance, not a precise timestamp.
export const relTime = (dt, now = new Date()) => {
  const d = dt instanceof Date ? dt : new Date(dt);
  if (isNaN(d)) return '';
  const mins = Math.round((now - d) / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  return dayLabel(d);
};

export const greeting = (name) => {
  const h = new Date().getHours();
  const sal = h < 12 ? 'Good morning' : h < 17 ? 'Good afternoon' : 'Good evening';
  return name ? `${sal}, ${name.split(' ')[0]}` : sal;
};
